import type { DismissCloneJobResponse, ListCloneJobsResponse } from "@repo/shared/types";
import { del, get } from "./_client";

/** QL-334 — the tenant's background (translated) copies. */
export function listCloneJobs() {
  return get<ListCloneJobsResponse>("/internal/clone-jobs");
}

/** Dismiss a failed copy or cancel a queued one. */
export function dismissCloneJob(id: string) {
  return del<DismissCloneJobResponse>(`/internal/clone-jobs/${id}`);
}
